define(['moment-wrapper', 'modules/common/controls/datepicker'], (moment, Input) => Input.extend({
    canPublish: true,

    binders: _.extend({}, Input.prototype.binders, {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    view.canPublish ? publish(view.get()) : {};
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        }
    }),

    render () {
        Input.prototype.render.apply(this, arguments);

        this.$el.datetimepicker('destroy').datetimepicker(this.options);
        return this;
    },

    get () {
        const date = this.$el.datetimepicker('getDate');
        return date ? moment(date).formatDateTimeApi() : null;
    },

    set (date) {
        if (date) {
            this.canPublish = false;
            this.$el.datetimepicker('setDate', moment(date).toDate());
            this.canPublish = true;
        }
    },

    remove () {
        this.$el.datetimepicker('hide').datetimepicker('destroy');

        return Input.prototype.remove.apply(this, arguments);
    }

}));
